import script from "./LeaderProjectTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectTeam.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectTeam.vue?vue&type=style&index=0&id=04111918&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04111918"]])

export default __exports__